
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
@Component
export default class CarForm extends Vue{

    @Prop({default:null})
    row:any;

    @Prop({default:false})
    readonly!:boolean;

    @Watch("row", { immediate: true })
    public watchRow() {
        if (this.row)
            this.Model = { ...this.row ,isDeleted:this.row.isDeleted?1:0 };
    }

    Model = {
        number:'',
        color:'',
        brand:'',
        type: '',
        engineNo:'',
        initMileage:0,
        currentMileage:0,
        isDeleted: 0,
    }
    Clear(){
        this.Model = {
            number: '',
            color: '',
            brand: '',
            type: '',
            engineNo: '',
            initMileage: 0,
            currentMileage: 0,
            isDeleted: 0,
        }
    }
}
